$(".search-btn").on("click", function (e) {
  e.preventDefault()
  // $('body').toggleClass('search-mode');
  const li = $(this).parent()
  if (!li.find(".search-panel").length) {
    const template = `
        <div class="search-panel">
            <div class="search-header">
                <input type="search" class="form-control search-input" placeholder="${
                  algoras.translate["Type to search..."] || "Type to search..."
                }">
            </div>
            <div class="search-body"></div>
        </div>
    `
    li.append(template)

    const searchHandler = debounce(
      (input) => {
        // li.find(".search-body").removeClass("active")
        search(input, (contents) => {
          const notFound = "No results found for keyword"
          let tmp = `
            <div class="not-found">${
              algoras.translate[notFound] || notFound
            }: ${input.val()}</div>
          `
          if (contents.length) {
            tmp = `
            ${contents
              .map(
                (content) => `
                <a href="${content.url}" class="item" data-id="${content.id}">
                    <div class="title">${content.local.title}</div>
                </a>
            `,
              )
              .join("")}
          `
          }
          li.find(".search-body").html(tmp).addClass("active")
        })
      },
      350,
      true,
    )
    li.find(".search-input").on("input", function () {
      searchHandler($(this))
    })

    $(document).mouseup(function (e) {
      if (!li.is(e.target) && li.has(e.target).length === 0) {
        li.find(".search-panel").removeClass("show")
        li.find(".search-panel .search-body").removeClass("active").empty()
        li.find(".search-input").val("");
      }
    })
  }

  const panel = li.find(".search-panel")
  panel.toggleClass("show")

  setTimeout(() => {
    panel.find(".search-input")[0].focus()
  }, 500)
})

let currentRequest = null
function search(input, callback) {
  const keyword = input.val().trim()
  if (keyword) {
    const url = algoras.url
      .replace("__CONTROLLER__", "content")
      .replace("__ACTION__", "search")
    $.ajaxSetup({ cache: false })
    if (currentRequest != null) {
      currentRequest.abort()
      currentRequest = null
    }
    currentRequest = $.ajax({
      type: "post",
      dataType: "json",
      url,
      data: { keyword },
      success: function (response) {
        callback(response)
      },
      beforeSend: function () {
        //
      },
      error: function (jqXHR, exception) {
        let msg = ""
        if (jqXHR.status === 0) {
          msg = "Not connect, Verify Network."
        } else if (jqXHR.status == 404) {
          msg = "Requested page not found. [404]"
        } else if (jqXHR.status == 500) {
          msg = "Internal Server Error [500]."
        } else if (exception === "parsererror") {
          msg = "Requested JSON parse failed."
        } else if (exception === "timeout") {
          msg = "Time out error."
        } else if (exception === "abort") {
          msg = "Ajax request aborted."
        } else {
          msg = "Uncaught Error : " + jqXHR.responseText
        }
        console.log(msg)
      },
    })
  }
}

function debounce(callback, wait, immediate = false) {
  let timeout = null

  return function () {
    const callNow = immediate && !timeout
    const next = () => callback.apply(this, arguments)

    clearTimeout(timeout)
    timeout = setTimeout(next, wait)

    if (callNow) {
      next()
    }
  }
}
